import Cookies from 'js-cookie';
import { isGAEnabled } from 'services/analytics/eventTracking';

export const getSessionIdSessionNumber = (sessionData?: string) => {
    if (!sessionData) {
        return;
    }

    const sessionDataArray = sessionData.split('.');

    return [sessionDataArray[2], sessionDataArray[3]];
};

export const getGoogleAnalyticsSessionData = () => {
    if (!isGAEnabled) {
        return {};
    }

    const cookieGoogleAnalytics = Cookies.get(
        `_ga_${config.ANALYTICS_GA_EVENT_MEASUREMENT_ID}`,
    );
    const parts = getSessionIdSessionNumber(cookieGoogleAnalytics);

    if (!parts) {
        return {};
    }

    return {
        session_id: parts[0],
        session_number: parts[1],
    };
};

export const getGoogleAnalyticsClientId = () => {
    if (!isGAEnabled) {
        return {};
    }

    const cookieGoogleAnalytics = Cookies.get('_ga');

    return cookieGoogleAnalytics
        ? {
              client_id: cookieGoogleAnalytics.substring(6),
          }
        : {};
};
